module.exports = __webpack_public_path__ + "static/img/C-020_ 1_1.c56911f.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/C-020_ 1_1.png
// module id = VGa2
// module chunks = 0